import React from "react";
import ContactLinks from "../contact-links/ContactLinks";
import Header from "../header/Header";
import { Section } from "./Home.style";
import Balls from "../balls/Balls";

const Home = () => (
  <>
    <Balls />
    <Section>
      <Header />
      <ContactLinks />
    </Section>
  </>
);

export default Home;
